import Breadcrumbs from './breadcrumbs';
export { BreadcrumbSegment, type BreadcrumbSegmentProps } from './BreadcrumbSegment';
export { type Breadcrumb, BreadcrumbType } from './types';
export { createBreadcrumbs, generateBreadcrumbs } from './utils';
export default Breadcrumbs;
